module.exports = __webpack_public_path__ + "static/media/buy_history_3.1c4aaa18.png";